module.exports = __webpack_public_path__ + "static/media/fig_23d.e825e469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_23d.jpg
// module id = 661
// module chunks = 0